import React, {useEffect, useState} from "react";
import MainContainer from "../../components/MainContainer";
import {Link} from "react-router-dom";
import {xReqId} from "../../utils";
import {RotatingLines} from "react-loader-spinner";
import MasterStatsTable from "./components/MasterStatsTable";
import SlaveStatsTables from "./components/SlaveStatsTables";

const TransferStatsPage = () => {
    const [loading, setLoading] = useState(false);
    const [events, setEvents] = useState([]);
    const [error, setError] = useState(null);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [detailedMetrics, setDetailedMetrics] = useState(null);
    const [detailedLoading, setDetailedLoading] = useState(false);


    const fetchStats = async () => {
        setLoading(true);
        try {
            const res = await fetch("/api/stats/seasonal/event/transfers", {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "x-request-id": xReqId,
                },
            });
            if (res.ok) {
                const data = await res.json();
                setEvents(data);
            } else {
                setError("Αδυναμία ανάκτησης στατιστικών.");
            }
        } catch (err) {
            setError("Κάτι πήγε στραβά.");
        } finally {
            setLoading(false);
        }
    };

    const fetchDetailedStats = async (eventCode) => {
        setDetailedLoading(true);
        setDetailedMetrics(null);
        try {
            const res = await fetch(`/api/stats/eligible/amka/transfers/${eventCode}`, {
                method: "GET",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "x-request-id": xReqId,
                },
            });
            if (res.ok) {
                const data = await res.json();
                setDetailedMetrics(data);
            } else {
                setError("Αδυναμία ανάκτησης λεπτομερών στατιστικών.");
            }
        } catch (err) {
            setError("Κάτι πήγε στραβά κατά την ανάκτηση λεπτομερειών.");
        } finally {
            setDetailedLoading(false);
        }
    };

    useEffect(() => {
        fetchStats();
    }, []);

    const handleRowClick = (event) => {
        setSelectedEvent(event);
        fetchDetailedStats(event.eventCode);
    };


    return (
        <MainContainer>
            <div className="col-lg-12">
                <Link to="/ticket-office/choose-user" className="btn btn-back mb-4">
                    <svg
                        className="govgr-svg-icon--caret govgr-svg-icon"
                        focusable="false"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                    >
                        <path d="M18,22V2L6,12L18,22z"></path>
                    </svg>
                    Πίσω
                </Link>
                <h2 className="mb-4">Στατιστικά Μεταβιβάσεων</h2>

                {loading ? (
                    <div className="d-flex justify-content-center">
                        <RotatingLines strokeColor="grey" strokeWidth="5" animationDuration="0.75" width="96" visible={true} />
                    </div>
                ) : error ? (
                    <div className="alert alert-danger">{error}</div>
                ) : (
                    <>
                        <MasterStatsTable 
                            events={events} 
                            selectedEvent={selectedEvent} 
                            handleRowClick={handleRowClick} 
                        />

                        {detailedLoading && (
                            <div className="d-flex justify-content-center mt-4">
                                <RotatingLines strokeColor="grey" strokeWidth="5" animationDuration="0.75" width="64" visible={true} />
                            </div>
                        )}

                        {detailedMetrics && (
                            <SlaveStatsTables 
                                detailedMetrics={detailedMetrics} 
                                selectedEvent={selectedEvent}
                            />
                        )}
                    </>
                )}
            </div>
        </MainContainer>
    );
};

export default TransferStatsPage;
